import { Action } from 'helpers/action-helpers';
import { OperationItem } from 'types/operation-item';

export const ENABLE_SCANNER_ACTION = 'EnableScannerAction';
export const EPC_SCAN_ACTION = 'EpcScanAction';
export const EPC_INVALID_ACTION = 'EpcInvalidAction';
export const LOGIN_CARD_SCAN_ACTION = 'LoginCardScanAction';
export const ADD_PENDING_ITEM_ACTION = 'AddPendingItemAction';
export const USER_BARCODE_SCAN_ACTION = 'UserBarcodeScanAction';

export class ScanAction extends Action {
  constructor(
    type: string,
    public epc: string,
    public isCapsLockOn: boolean,
    public isSeparatorMissing: boolean) { 
    super(type);
  }
}

export class AddPendingItemAction extends Action {
  constructor(public item: OperationItem, public key: string) { 
    super(ADD_PENDING_ITEM_ACTION);
  }
}


// WEBPACK FOOTER //
// ./src/components/scanner/actions.ts